import type { AxiosRequestConfig } from 'axios'
import { isSuperAdminRole } from '@/shared/libs/admin-routes'
import { getStoredUser } from '@/shared/libs/get-auth-token'

/**
 * IAM answers 403 to `X-Tenant-Id` from anyone but a super admin; every other admin is scoped
 * by the tenant in their token. Without a session user yet (e.g. login) nothing is withheld.
 */
export function canSendTenantHeader(): boolean {
  const user = getStoredUser()
  return user === null || isSuperAdminRole(user.role)
}

export function buildTenantHeaderConfig(tenantId?: string | null): AxiosRequestConfig {
  return tenantId && canSendTenantHeader() ? { headers: { 'X-Tenant-Id': tenantId } } : {}
}
